import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Container, Alert, Col, Row, Modal } from 'react-bootstrap';
import { firestore } from "../../firebase";
import { useHistory } from 'react-router-dom';

export default function CreateProduct() {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [proveedores, setProveedores] = useState([]);
    const [codigo, setCodigo] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [cantActual, setCantActual] = useState(0);
    const [cantMin, setCantMin] = useState(0);
    const [categoria, setCategoria] = useState("");
    const [proveedorSelect, setProveedorSelect] = useState("");
    const [newProveedor, setNewProveedor] = useState("");
    const [divisa, setDivisa] = useState("CRC");
    const [precio, setPrecio] = useState(0);
    const [notas, setNotas] = useState("");
    const history = useHistory();

    function getProveedores() {
        setLoading(true);

        const proveedoresQuery = firestore.collection('proveedores').orderBy('nombre');
        proveedoresQuery.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                const data = doc.data();
                items.push({
                    id: doc.id,
                    nombre: data.nombre
                })
            })
            setProveedores(items);
            setLoading(false);
        })
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        if (!codigo || !descripcion || cantActual === '' || cantMin === '' ||
            !categoria || (!proveedorSelect && !newProveedor) || !divisa ||
            precio === '') {
                setError("Uno o más campos requeridos no llenados");
                setLoading(false);
                return null;
            }

        const createCodigo = codigo.trim();
        const createDescripcion = descripcion.trim();
        const createCantActual = cantActual;
        const createCantMin = cantMin;
        const createCategoria = categoria.trim();
        const createProveedor = proveedorSelect ? proveedorSelect.trim() : newProveedor.trim();
        const createDivisa = divisa.trim();
        const createPrecio = precio;
        const createNotas = notas.trim();
    
        setCodigo(createCodigo);
        setDescripcion(createDescripcion);
        setCategoria(createCategoria);
        setProveedorSelect(proveedorSelect.trim());
        setNewProveedor(newProveedor.trim());
        setDivisa(createDivisa);
        setNotas(createNotas);

        if (createCantActual < 0 || createCantMin < 0) {
            setError("Las cantidades no pueden ser menores a 0");
            setLoading(false);
            return null;
        }

        if (createPrecio < 0) {
            setError("El precio no puede ser menor a 0");
            setLoading(false);
            return null;
        }

        const duplicatesCodigo = await firestore
            .collection('productos')
            .where('codigo', '==', createCodigo)
            .get();

        if (!duplicatesCodigo.empty) {
            setError("El código del producto ya está en uso");
            setLoading(false);
            return null;
        }

        const newProduct = {
            codigo: createCodigo,
            descripcion: createDescripcion,
            proveedor: createProveedor,
            categoria: createCategoria,
            cantidad: {
                actual: parseInt(String(createCantActual)),
                min: parseInt(String(createCantMin))
            },
            precio: {
                divisa: createDivisa,
                cantidad: Number(createPrecio)
            },
            notas: createNotas,
            keywords: []
        }

        firestore.collection('productos').add(newProduct)
        .then(() => {
            setShowAlert(true);
            setLoading(false);
        })
        .catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setLoading(false);
        })
    }

    function handleClose() {
        setShowAlert(false);
        history.push("/products");
    }

    useEffect(() => {
        getProveedores();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Container 
        className="d-flex align-items-center justify-content-center"
        >
            <div className="w-100" style = {{ maxWidth: "500px"}}>
                <h2 className="text-center mt-3 mb-4">Crear Producto</h2>
                <Modal show={showAlert} onHide={handleClose}>
                    <Modal.Header>
                        <Modal.Title>Éxito</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Se creó el producto correctamente
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleClose}>
                            Regresar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Card>
                    <Card.Body>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="producto-codigo">
                                    <Form.Label>Código</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    value={codigo}
                                    onChange={e => setCodigo(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="producto-description">
                                    <Form.Label>Nombre/Descripción</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    value={descripcion}
                                    onChange={e => setDescripcion(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Col xs={6}>
                                    <Form.Group className="mb-3" id="producto-cantidad-actual">
                                        <Form.Label>Cantidad Actual</Form.Label>
                                        <Form.Control 
                                        type="number" 
                                        value={cantActual}
                                        onChange={e => setCantActual(e.target.value)}
                                        disabled={loading}/>
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group className="mb-3" id="producto-cantidad-min">
                                        <Form.Label>Cantidad Mínima</Form.Label>
                                        <Form.Control 
                                        type="number" 
                                        value={cantMin}
                                        onChange={e => setCantMin(e.target.value)}
                                        disabled={loading}/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="m-2">
                                <Col xs={12} sm={6}>
                                    <Form.Group className="mb-3" id="producto-select-categoria">
                                        <Form.Control
                                        as="select" custom
                                        value={categoria}
                                        onChange={e => setCategoria(e.target.value)}
                                        disabled={loading}
                                        >
                                            <option value="">Escoja una categoría</option>
                                            <option value="Equipo">Equipo</option>
                                            <option value="Consumible">Consumible</option>
                                            <option value="Repuesto">Repuesto</option>
                                            <option value="Otro">Otro</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Group className="mb-3" id="producto-select-proveedor">
                                    <Form.Control
                                        as="select" custom
                                        value={proveedorSelect}
                                        onChange={e => {
                                            setProveedorSelect(e.target.value);
                                            setNewProveedor("")
                                        }}
                                        disabled={loading}
                                        >
                                            <option value="">Escoja un proveedor</option>
                                            {proveedores 
                                            && proveedores.map(p => {
                                                return (
                                                    <option key={p.id} value={p.nombre}>{p.nombre}</option>
                                                )
                                            })}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='m-2'>
                                <Col xs={12}>
                                    <Form.Group className="mb-3" id="producto-new-proveedor">
                                        <Form.Label>...o ingrese un nuevo proveedor</Form.Label>
                                        <Form.Control 
                                        type="text"
                                        value={newProveedor}
                                        onChange={e => {
                                            setNewProveedor(e.target.value);
                                            setProveedorSelect("");
                                        }}
                                        disabled={loading}/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="m-2">
                                <Col xs={12} sm={3}>
                                    <Form.Group className="mb-3" id="producto-select-divisa">
                                        <Form.Label>Divisa</Form.Label>{' '}
                                        <Form.Control
                                        as="select" custom
                                        value={divisa}
                                        onChange={e => setDivisa(e.target.value)}
                                        disabled={loading}
                                        >
                                            <option value="CRC">CRC</option>
                                            <option value="USD">USD</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} sm={9}>
                                    <Form.Group className="mb-3" id="producto-precio">
                                        <Form.Label>Precio</Form.Label>
                                        <Form.Control 
                                        type="number"
                                        value={precio}
                                        onChange={e => setPrecio(e.target.value)}
                                        disabled={loading}/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="producto-notas">
                                    <Form.Label>Notas (opcional)</Form.Label>
                                    <Form.Control 
                                    as="textarea" rows={3}
                                    value={notas}
                                    onChange={e => setNotas(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className='m-2'>
                                <Col xs={3}>
                                    <Button disabled={loading} type="submit">Confirmar</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    )
}